var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('car-detail',{attrs:{"car-detail":_vm.detailData,"show-price":true,"operate-info":_vm.checkEvaluate},on:{"on-go":_vm.checkComplete}})}
var staticRenderFns = []

export { render, staticRenderFns }